import { h, Host } from "@stencil/core";
export class Slide {
    constructor() {
        this.label = "";
    }
    render() {
        return (h(Host, { key: '560d910c2894488d5e6ede183c1a79f33273207e', class: "ux-slider-slide" }, h("slot", { key: '08bbf42492a15806675607a9d5f4cb597aff4ab2' })));
    }
    static get is() { return "ux-slider-slide"; }
    static get originalStyleUrls() {
        return {
            "$": ["slider-slide.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["slider-slide.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "label of the slide"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
}
//# sourceMappingURL=slider-slide.js.map
